// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { Box, Typography } from "@outschool/backpack";
import { useFeatureFlag } from "@outschool/ui-components-shared";
import React from "react";

import HeroLayoutWithTabs from "../../layout/HeroLayoutWithTabs/HeroLayoutWithTabs";
import { learnerRoutes } from "../../lib/Routes";
import { NotFoundPage } from "../NotFoundPage";

export default function LearnerDiscovery() {
  const isMixUpEnabled = useFeatureFlag("nav-pod-mix-up-machine");
  if (!isMixUpEnabled) {
    return <NotFoundPage />;
  }

  return (
    <HeroLayoutWithTabs currentPath={learnerRoutes.discoveryPath()}>
      <Box
        flex
        sx={{
          flexDirection: "column",
          marginTop: "1.5rem",
        }}
      >
        <Typography variant="h2">The Mix-Up Machine</Typography>
        <Typography
          variant="body1"
          sx={{ color: "grey.600", marginTop: "1rem" }}
        >
          Select 2 topics and mix them to explore your interests.
        </Typography>
      </Box>
    </HeroLayoutWithTabs>
  );
}
